import { selectCurrentCourse } from '../../db/courses/selectors';
import { useAppSelector } from '../../store/hooks';
import { getIsDeadlineOver } from './helpers';

export default function useCourseFooterVM() {
  const course = useAppSelector((state) => selectCurrentCourse(state));
  const isDeadlineOver = getIsDeadlineOver({ course });
  return { isDeadlineOver };
}
